export default "__VITE_ASSET__D2sNkDgb__"